import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  to?: string;
  href?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  className?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
}
export function Button({
  children,
  to,
  href,
  variant = 'primary',
  className = '',
  icon,
  onClick
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 font-sub font-semibold py-3.5 px-8 rounded-btn transition-all duration-300 text-sm uppercase tracking-wider';
  const variants = {
    primary: 'bg-gold hover:bg-gold-light text-navy-900 shadow-gold hover:shadow-none',
    secondary: 'bg-navy-800 hover:bg-navy-700 text-white border border-navy-700 hover:border-gold',
    outline: 'bg-transparent border-2 border-gold text-gold hover:bg-gold hover:text-navy-900'
  };
  const combinedStyles = `${baseStyles} ${variants[variant]} ${className}`;
  if (to) {
    return <Link to={to} className={combinedStyles} onClick={onClick} data-id="element-99">
        {children}
        {icon && <span className="ml-1" data-id="element-100">{icon}</span>}
      </Link>;
  }
  if (href) {
    return <a href={href} className={combinedStyles} target="_blank" rel="noreferrer" onClick={onClick} data-id="element-101">
        {children}
        {icon && <span className="ml-1" data-id="element-102">{icon}</span>}
      </a>;
  }
  return <motion.button whileTap={{
    scale: 0.98
  }} className={combinedStyles} onClick={onClick} data-id="element-103">
      {children}
      {icon && <span className="ml-1" data-id="element-104">{icon}</span>}
    </motion.button>;
}